import { UpToDateBuildService } from './up-to-date-build.service';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable, isDevMode } from "@angular/core";
import { noop } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LogService {
    constructor(
        public http: HttpClient,
        private upToDateBuildService: UpToDateBuildService,
    ) { }

    get enabled(): boolean { return localStorage.getItem('disabled-logging-server-service') != 'yes'; }
    set enabled(value) {
        if (value) localStorage.setItem('disabled-logging-server-service', 'yes');
        else localStorage.removeItem('disabled-logging-server-service');
    }

    // prevent flood of duplicate errors to back-end log
    private _lastError?: string;
    private _lastErrorResetTimer?: number;
    private setErrorResetTimer() {
        if (this._lastErrorResetTimer) window.clearTimeout(this._lastErrorResetTimer);
        this._lastErrorResetTimer = window.setTimeout(() => { this._lastError = undefined; }, 15000);
    }

    log(user: string | null, args: any[] | IArguments | string | null, data?: string, ignoreDisabledLogging: boolean = false) {
        this.logType('log', user, args, data, ignoreDisabledLogging);
    }
    warn(user: string | null, args: any[] | IArguments | string | null, data?: string, ignoreDisabledLogging: boolean = false) {
        this.logType('warn', user, args, data, ignoreDisabledLogging);
    }
    error(user: string | null, args: any[] | IArguments | string | null, data?: string, ignoreDisabledLogging: boolean = false) {

        let thisError = JSON.stringify([user, args, data]);
        if (thisError == this._lastError) { this.setErrorResetTimer(); return; }
        this._lastError = thisError;
        this.setErrorResetTimer();

        this.logType('error', user, args, data, ignoreDisabledLogging);
    }

    logType_LEGACY(
        type: string,
        user: string | null,
        args: any[] | IArguments | string | null,
        data?: string,
        ignoreDisabledLogging: boolean = false,
    ) {
        if (user == null && args == null && data == null) return;

        // write to console
        let consoleFn: (...data: any[]) => void;
        switch (type) {
            case 'log': consoleFn = console.log; break;
            case 'warn': consoleFn = console.warn; break;
            case 'error': consoleFn = console.error; break;
            default: consoleFn = (...data: any[]) => {
                data.unshift(type);
                consoleFn = console.log;
            }
        }

        if (data !== undefined) consoleFn.apply(this, ['>> ', data]);

        if (!this.enabled && !ignoreDisabledLogging) return;

        // get the call stack data
        let stack = Error().stack
            // split by new line characters
            ?.split('\n')
            // remove opening 'Error', 'serverLog', 'log' -- start at stack that initially invoked the LogService call
            .splice(3)
            // remove leading white
            .map(item => item.trim());

        let jsonData: {
            type: string,
            user: string | null,
            version: string,
            args: string | null,
            stack: string | null,
            data: string | null
        } = {
            type: type,
            user: user,
            version: this.upToDateBuildService.buildNumberAtStartup,
            args: typeof args == 'string' ? args : JSON.stringify(args),
            stack: JSON.stringify(stack),
            data: null
        };
        if (data !== undefined) jsonData.data = data;

        // send it to the back-end logging server
        this.http.post(
            "https://api.mayerfabrics.com/wmslog",
            jsonData,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
                responseType: 'text',
                observe: 'response'
            }
        ).subscribe({
            next: (resp: any) => { },
            error: (error: any) => {
                console.warn('Error from Mayer API Logging Service', error);
            }
        })
    }

    logType(
        type: string,
        user: string | null,
        args: any[] | IArguments | string | null,
        data?: string,
        ignoreDisabledLogging: boolean = false,
    ) {
        if (user == null && args == null && data == null) return;

        // write to console
        let consoleFn: (...data: any[]) => void;
        switch (type) {
            case 'log': consoleFn = console.log; break;
            case 'warn': consoleFn = console.warn; break;
            case 'error': consoleFn = console.error; break;
            default: consoleFn = (...data: any[]) => {
                data.unshift(type);
                consoleFn = console.log;
            }
        }

        if (data !== undefined) consoleFn.apply(this, ['>> ', data]);

        if (!this.enabled && !ignoreDisabledLogging) return;

        // get the call stack data
        let stack = Error().stack
            // split by new line characters
            ?.split('\n')
            // remove opening 'Error', 'serverLog', 'log' -- start at stack that initially invoked the LogService call
            .splice(3)
            // remove leading white
            .map(item => item.trim());

        let jsonData: {
            type: string,
            username: string | null,
            version: string,
            args: string | null,
            callstack: string | null,
            data: string | null
        } = {
            type: type,
            username: user,
            version: this.upToDateBuildService.buildNumberAtStartup,
            args: typeof args == 'string' ? args : JSON.stringify(args),
            callstack: JSON.stringify(stack),
            data: null
        };
        if (data !== undefined) jsonData.data = data;

        // send it to the back-end logging server
        this.http.post(
            isDevMode() ? "https://nhook.com:7188/log/wms" : "https://images.mayerfabrics.com/log/wms",
            jsonData,
            {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                }),
                responseType: 'text',
                observe: 'response'
            }
        ).subscribe({
            next: noop,
            error: (error: any) => {
                console.warn('Error from Mayer API Logging Service', error);
            }
        })
    }
}
